module.exports = {
  about: ['about', 'about', 'presentazione'],
  artworks: ['artworks', 'opere'],
  blog: ['blog', 'blog'],
  contact: ['contact', 'contatto'],
};
